import { useEffect, useState } from 'react'
import Typography from '@mui/material/Typography'
import { formatLockoutCountdown } from '../lib/lockout'
import { paletteErrorMain } from '@/theme/designTokens'

interface LockoutCountdownProps {
  readonly lockedUntilMs: number
  readonly message?: string
}

export function LockoutCountdown({
  lockedUntilMs,
  message = 'Too many failed attempts. Please wait before trying again.',
}: LockoutCountdownProps) {
  const [remaining, setRemaining] = useState(() =>
    Math.max(0, Math.ceil((lockedUntilMs - Date.now()) / 1000))
  )

  useEffect(() => {
    const tick = () => {
      setRemaining(Math.max(0, Math.ceil((lockedUntilMs - Date.now()) / 1000)))
    }
    tick()
    const id = globalThis.setInterval(tick, 1000)
    return () => globalThis.clearInterval(id)
  }, [lockedUntilMs])

  if (remaining <= 0) return null

  return (
    <Typography
      role="status"
      aria-live="polite"
      data-testid="auth-lockout-countdown"
      sx={{
        color: paletteErrorMain,
        fontSize: '14px',
        lineHeight: '20px',
        textAlign: 'center',
        mt: 1,
      }}
    >
      {message} ({formatLockoutCountdown(remaining)})
    </Typography>
  )
}
